import { HOME_HERO_REQUEST, HOME_HERO_SUCCESS, HOME_HERO_FAIL } from '../constants/homeConstants'

export const homeHeroReducer = (state = { data: null, loading: false }, action) => {
    switch (action.type) {
        case HOME_HERO_REQUEST:
            return { ...state, loading: true }
        case HOME_HERO_SUCCESS:
            return { loading: false, data: action.payload }
        case HOME_HERO_FAIL:
            return { loading: false, error: action.payload, data: null }
        default:
            return state
    }
}
